<template>
  <div
    :class="[
      'custom-icon-button',
      {
        'custom-icon-button--active': active
      }
    ]"
    @click="onClick"
  >
    <template v-if="hasSlot()">
      <slot class="custom-icon-button__icon"></slot>
    </template>
    <template v-else>
      <b-icon
        :icon="icon"
        :scale="scale"
        class="custom-icon-button__icon"
      ></b-icon>
    </template>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Custom icon button
 * ==================================================================================
 **/

export default {
  props: {
    icon: {
      type: String,
      default: 'grid'
    },
    active: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Number,
      default: 1.5
    }
  },
  methods: {
    onClick() {
      this.$emit('clicked')
    },
    hasSlot(name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-icon-button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #b5b5b5;
  border-radius: 4px;
  cursor: pointer;

  &__icon {
    max-width: 100%;
    color: #b5b5b5;
  }
}

.custom-icon-button--active,
.custom-icon-button:hover {
  border: 1px solid var(--brand-green);

  .custom-icon-button__icon {
    color: var(--brand-green);
  }
}
</style>
